import { DivConst } from 'constants/divConst';
import type { SignupCompanyData } from '../types';
import { getDivLabel } from 'utils/app';

export function buildSignupSignatureHtml(signupData: SignupCompanyData): string {
  const zipCode = signupData.zipCode.replace(/(\d{3})(\d{4})/, '$1-$2');
  const prefecture =
    signupData.prefectureDiv &&
    parseInt(signupData.prefectureDiv) !== DivConst.items.prefecture.abroad.value
      ? getDivLabel('prefecture', parseInt(signupData.prefectureDiv))
      : '';
  const address = [prefecture, signupData.city, signupData.address, signupData.buildingName]
    .filter(Boolean)
    .join('');

  return `
      <p>ーーーーーーーーーーーーーー</p>
      <p>${signupData.companyName}</p>
      <p>〒${zipCode}</p>
      <p>${address}</p>
    `;
}
